var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative bg-thumb",class:_vm.pb},[_c('img',{staticClass:"absolute w-full h-full",class:_vm.classes,attrs:{"src":_vm.blank,"data-src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }